import { ErrorMessage } from "src/app/core/constants/validation-msg-constants";
import { CouponConfirmationModalComponent } from "./../../../shared/components/coupon-confirmation-modal/coupon-confirmation-modal.component";
import { ActivatedRoute, Router } from "@angular/router";
import { TaxAndChargesModalComponent } from "./../../../shared/components/tax-and-charges-modal/tax-and-charges-modal.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Injectable, ChangeDetectorRef, NgZone } from "@angular/core";
import { ApiRequestService } from "../../../shared/services/api-request.service";
import { AppData, ToastService } from "src/app/shared";
import { getConfig, getMessages } from "src/app/core/constants/app-constants";
import { ChangeAddressModalComponent } from "src/app/shared/components/add-edit-address-component/change-address-modal/change-address-modal.component";
import { AddAddressOnCartModalComponent } from "src/app/shared/components/add-edit-address-component/add-address-on-cart-modal/add-address-on-cart-modal.component";
import {
  updateCustomizeItemObj,
  modalAddonVariantsObj,
  preCheckoutReqObj,
} from "src/app/shared/utils/menu-cart-item-functions";
import { AddonVariantComponent } from "../../modals/addon-variant/addon-variant.component";
import { ConfirmationModalComponent } from "../../modals/confirmation-modal/confirmation-modal.component";
import { LoaderService } from "src/app/shared/services/loader.service";
import {
  addItemInCartCleverTapObj,
  clearCartAnalyticObj,
  paymentFailedObj,
  paymentSuccessFailedCleverTapEvent,
  paymentSuccessObj,
  removeItemInCartCleverTapObj,
} from "src/app/shared/utils/clever-tab-functions";
import { CLEVER_TAP_EVENT } from "src/app/core/constants/clever-tab-event-constants";
import { ScratchCardModalComponent } from "src/app/shared/components/scratch-card-modal/scratch-card-modal.component";
import { PaymentModalComponent } from "src/app/shared/components/payment-modal/payment-modal.component";
import { AnalyticsService } from "src/app/shared/services/analytics.service";

import { OrderConfirmationModalComponent } from "../../modals/order-confirmation-modal/order-confirmation-modal.component";
import { MenuItemService } from "../../restaurant-details/service/menu-item.service";
import { BehaviorSubject, Subject, Subscription } from "rxjs";
import { NavController } from "@ionic/angular";

@Injectable({
  providedIn: "root",
})
export class CartService {
  onPreCheckOutletPlate: any; //method variable
  onSetPlateView: any; //method variable
  onEmptyPlateView: any; //method variable

  interval: any;
  setTimer: any;
  pollingCount = 0;
  changeDetector: ChangeDetectorRef;
  enableAPiCall = true

  constructor(
    private apiRequestService: ApiRequestService,
    private modalService: NgbModal,
    private loaderService: LoaderService,
    private toast: ToastService,
    private ngZone: NgZone,
    private router: Router,
    private navCtrl: NavController,
    private analyticsService: AnalyticsService,
    private menuItemService: MenuItemService,
    private activatedRoute: ActivatedRoute
  ) {
  }

  init(cd: ChangeDetectorRef, preCheckoutPlate, setPlateView, setEmptyPlate) {
    this.changeDetector = cd;
    this.onPreCheckOutletPlate = preCheckoutPlate;
    this.onSetPlateView = setPlateView;
    this.onEmptyPlateView = setEmptyPlate;
  }

  // get cart id
  getCartData(obj) {
    return this.apiRequestService.get("getCart", "?cartId=" + obj);
  }

  // add item on plate
  addItemsToCart(obj) {
    return this.apiRequestService.post("addItem", obj);
  }

  // update variant and addons
  updateAddonVariant(obj, ind) {
    return this.apiRequestService.put("updateAddonVariant", "/" + ind, obj);
  }

  // change item count
  changeItemCount(itemIndex, itemCount, obj) {
    console.log(itemIndex, itemCount, obj);
    return this.apiRequestService.patch(
      "changeItemCount",
      itemIndex + "/" + itemCount,
      obj
    );
  }

  // pre checkout
  async preCheckout() {
    const reqBody = await preCheckoutReqObj();
    return this.apiRequestService.post("preOrderCheckout", reqBody);
  }

  // place new order
  placeOrders(reqObj) {
    return this.apiRequestService.post("placeOrder", reqObj);
  }

  // post checkout api and check order status
  postCheckout(orderId) {
    return this.apiRequestService.get("postCheckout", "?orderId=" + orderId);
  }

  // get all coupons list
  getAllCoupon(cartId) {
    return this.apiRequestService.get("getAllCoupon", "?cartId=" + cartId);
  }

  // apply coupon
  applyCoupon(reqBody) {
    return this.apiRequestService.post("applyCoupon", reqBody);
  }

  // apply partial pay
  applyPartialPay(reqBody) {
    return this.apiRequestService.post("applyPartialPay", reqBody);
  }

  // remove partial pay
  removePartialPay(reqBody) {
    return this.apiRequestService.post("removePartialPay", reqBody);
  }

  // schedule slot
  scheduleSlot(outletId, selectedDate) {
    return this.apiRequestService.get("scheduleSlot", "?outletId=" + outletId + "&date=" + selectedDate);
  }

  // sechedule delivery
  secheduleDelivery(reqBody) {
    return this.apiRequestService.post("secheduleDelivery", reqBody.data);
  }

  setAndUpdateUserLoc(reqObj) {
    return this.apiRequestService.post("updateLocation", reqObj);
  }
  async noSelfPickupOrder() {
    const reqBody = preCheckoutReqObj();
    await this.apiRequestService.post("noSelfPickup", reqBody).then((res) => {
      AppData.deliveryType = res["body"]["data"]["cartDoc"].deliveryInfo.selfPickup ? "self-pickup" : "delivery";
      this.preCheckout().then(async (res) => {
        const responseData = res["body"]["data"];
        await this.onSetPlateView(responseData);
      });
    });
    return AppData.deliveryType;
  }
  async selfPickupOrder() {
    const reqBody = preCheckoutReqObj();
    await this.apiRequestService.post("selfPickup", reqBody).then((res) => {
      AppData.deliveryType = res["body"]["data"]["cartDoc"].deliveryInfo.selfPickup ? "self-pickup" : "delivery"; this.preCheckout().then(async (res) => {
        const responseData = res["body"]["data"];
        await this.onSetPlateView(responseData);
      });
    });
    return AppData.deliveryType;
  }

  // remove coupon
  removeCoupon(couponCode) {
    const reqBody = { couponCode: couponCode, cartId: AppData.cartId };
    this.apiRequestService.delete("removeCoupon", "", reqBody).then((res) => {
      const responseData = res["data"];
      console.log(responseData);
      this.preCheckout().then(async (res) => {
        const responseData = res["body"]["data"];
        await this.onSetPlateView(responseData);
      });
    });
  }

  // call function when outlet will close and delivery person unavailable
  clearYourPlate() {
    const reqBody = { cartId: AppData.cartId };
    return this.apiRequestService
      .delete("clearPlate", "", reqBody)
      .then(async (res) => {
        await this.onEmptyPlateView();
        this.router.navigate(["/home"]);
        AppData.bottomNavMobileIndSub$.next(0);
      });
  }

  getYumzyBal() {
    return this.apiRequestService.get(
      "getWalletPoints",
      `?mobile=${AppData.userInfoData.mobile}`
    );
  }

  useYumzyBalance(reqBody) {
    return this.apiRequestService.post("useWallet", reqBody);
  }

  unUseYumzyBalance(reqBody) {
    return this.apiRequestService.post("unUseWallet", reqBody);
  }

  // for increase dish count and call change item quantity api
  async increaseItemQuantity(itemObj, itmInd, outletId) {
    // const loaderDoc = document.getElementById(itemObj.quantity + "loader");
    // loaderDoc.style.display = "block";
    if (this.enableAPiCall) {
      await this.changeItemQuantity(++itemObj.quantity, itmInd, outletId);
      const outletLocality = AppData.yourPlateItems.outlets[0].locality;

      this.analyticsService.cleverTapEvent(
        CLEVER_TAP_EVENT.ITEM_ADDED_CART,
        addItemInCartCleverTapObj(itemObj, outletLocality)
      );
    }
  }

  // for decrease dish count and call change item quantity api
  async decreaseItemQuantity(itemObj, itmInd, outletId) {
    if (this.enableAPiCall) {
      // this.loaderService.show(false)
      // const loaderDoc = document.getElementById(itemObj.quantity + 'loader');
      // loaderDoc.style.display = "block";
      await this.changeItemQuantity(--itemObj.quantity, itmInd, outletId);
      this.analyticsService.cleverTapEvent(
        CLEVER_TAP_EVENT.ITEM_REMOVED_CART,
        removeItemInCartCleverTapObj(itemObj)
      );
    }
  }

  // change quantity count
  async changeItemQuantity(quantity, itmInd, outletId) {
    const btnDoc = document.getElementById(itmInd);
    this.enableAPiCall = false;
    const loaderDoc = document.getElementById(itmInd + 'loader');
    loaderDoc.style.display = "block";
    if (btnDoc) {
      btnDoc.style.pointerEvents = "none";
    }
    if (loaderDoc) {
      loaderDoc.style.display = "unset";
    }

    const body = { outletId: outletId, cartId: AppData.cartId };
    this.changeItemCount(itmInd, quantity, body)
      .then(async (res) => {
        this.loaderService.show(false)
        const responseData = res["body"]["data"];
        console.log(responseData);
        this.enableAPiCall = true;
        if (responseData["outlets"].length > 0) {
          this.preCheckout().then((res) => {
            const response = res["body"]["data"];
            this.onSetPlateView(response);
            this.loaderService.hide()
            if (loaderDoc) {
              loaderDoc.style.display = "none";
            }
            if (btnDoc) {
              btnDoc.style.pointerEvents = "unset";
            }
          });
        } else {
          this.enableAPiCall = true;
          await this.onEmptyPlateView();
          this.loaderService.hide()
          // on set plate view empty
          if (loaderDoc) {
            loaderDoc.style.display = "none";
          }
          if (btnDoc) {
            btnDoc.style.pointerEvents = "unset";
          }
        }

      })
      .catch(() => {
        if (loaderDoc) {
          loaderDoc.style.display = "none";
        }

        this.enableAPiCall = true;
        if (btnDoc) {
          btnDoc.style.pointerEvents = "unset";
        }
        this.loaderService.hide()
      });
  }

  // call function when item is not serving
  // async removeItemFormPlate(plateItemList, errorIds, outletId) {
  //   await plateItemList.forEach(async (plateObj, plateItemInd) => {
  //     await errorIds.forEach(async (idsObj, errorInd) => {
  //       if (plateObj.itemId === idsObj) {
  //         const body = { outletId: outletId, cartId: AppData.cartId };
  //         await this.changeItemCount(plateItemInd, 0, body).then((res) => {
  //           const isLastErrorId = errorIds[errorIds.length - 1];
  //           if (plateObj.itemId === isLastErrorId) {
  //             this.onPreCheckOutletPlate();
  //           }
  //         });
  //       }
  //     });
  //   });
  // }

  async removeUnavalItem(plateItemInd, outletId) {
    const body = { outletId: outletId, cartId: AppData.cartId };

    await this.changeItemCount(plateItemInd, 0, body).then((res) => {
      // const isLastErrorId = errorIds[errorIds.length - 1];
      // if (plateObj.itemId === isLastErrorId) {
      // const response = res["body"]["data"];
      this.preCheckout().then((res) => {
        const response = res["body"]["data"];
        this.onSetPlateView(response);
      });
      // }
    });
  }

  // for open change address modal
  onOpenAddressSelectModal(params) {
    const modalRef = this.modalService.open(
      ChangeAddressModalComponent,
      getConfig("CHANGE_ADDRESS_CONFIG")
    );
    modalRef.result
      .then(async (res) => {
        console.log(res);
        if (res.type === "CHANGE_ADR") {
          this.loaderService.show(false)
          const reqBody = {
            locality: res.locality ? res.locality : res.city,
            city: res.city,
            coordinates: res.longLat.coordinates,
          };
          await this.setAndUpdateUserLoc(reqBody).then(async (res) => {
            this.preCheckout().then((res) => {
              const response = res["body"]["data"];
              this.onSetPlateView(response);
              this.loaderService.hide()
            });
          });
        } else {
          this.onAddNewAddress(params);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  // for add new address
  onAddNewAddress(params) {
    const obj = {
      type: "ADD_ON_ADDRESS",
    };
    // const modalRef = this.modalService.open(
    //   AddEditAddressModalComponent,
    //   getConfig("FROM_RIGHT_MODAL")
    // );
    let navParams = {}
    if (params && Object.keys(params).length > 0) {
      navParams = JSON.parse(JSON.stringify(params))
    }
    navParams['type'] = 'ADD_ADDRESS'
    navParams['redirectUrl'] = window.location.pathname
    console.log(navParams)

    this.router.navigate(['add-edit-address'], { queryParams: navParams })
    // modalRef.componentInstance.modalObj = obj;
    // modalRef.result
    //   .then(async (res) => {
    //     const reqBody = {
    //       locality: res.locality ? res.locality : res.city,
    //       city: res.city,
    //       coordinates: res.longLat.coordinates,
    //     };
    //   AppData.currentAddressSub$.next(res);
    //   await this.setAndUpdateUserLoc(reqBody).then(async (res) => {
    //     this.preCheckout().then(async (res) => {
    //       const response = res["body"]["data"];
    //       this.onSetPlateView(response);
    //     });
    //   });
    // })
    // .catch((error) => {
    //   console.log(error);
    // });
  }
  async updateLocation(navStateData) {
    const reqBody = {
      locality: navStateData.locality,
      city: navStateData.city,
      coordinates: navStateData.coordinates,
    }
    AppData.currentAddressSub$.next(navStateData);
    await this.setAndUpdateUserLoc(reqBody).then(async (res) => {
      this.preCheckout().then(async (res) => {
        const response = res["body"]["data"];
        this.onSetPlateView(response);
      });
    });

  }

  openAddonsVariantModal(itemObj, ind) {
    console.log(itemObj);
    const items = JSON.parse(JSON.stringify(itemObj));
    const addonsVariantModalObj = modalAddonVariantsObj(items, ind);
    console.log(addonsVariantModalObj);
    const modalRef = this.modalService.open(
      AddonVariantComponent,
      getConfig("ADDON_VARIANT_CONFIG")
    );
    modalRef.componentInstance.modalObj = addonsVariantModalObj;
    modalRef.result
      .then((res) => {
        console.log(res);
        const item = res;
        this.onUpdateAddonAndVariant(item, ind);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  // for update addons and variants
  async onUpdateAddonAndVariant(item, ind) {
    const resBody = updateCustomizeItemObj(item);
    this.updateAddonVariant(resBody, ind).then((res) => {
      this.preCheckout().then((res) => {
        const responseData = res["body"]["data"];
        this.onSetPlateView(responseData);
      });
    });
  }

  openClearAllItemConfirmationModal(clearCartCleverTapObj) {
    const mObj = getMessages("CLEAR_ALL_DISH_MSG");
    const modalRef = this.modalService.open(
      ConfirmationModalComponent,
      getConfig("CONFIRM_MODAL_CONFIG")
    );
    modalRef.componentInstance.modalObj = mObj;
    modalRef.result
      .then(async (res) => {
        await this.clearYourPlate();
        this.analyticsService.cleverTapEvent(
          CLEVER_TAP_EVENT.CART_CLEARED,
          clearCartAnalyticObj(clearCartCleverTapObj)
        );
      })
      .catch((error) => {
        console.log(error);
      });
  }

  // for start polling for a order payment
  startOrderPolling(orderId, orderNum, outletId, totalAmount) {
    // this.onSetIsLoading(true);
    this.loaderService.show();
    this.interval = setInterval(() => {
      if (this.pollingCount <= 6) {
        this.postCheckoutPolling(orderId, orderNum, outletId, totalAmount);
      } else {
        this.clearPollingInterval();
      }
      this.pollingCount += 1;
    }, 2000);
  }

  postCheckoutPolling(orderId, orderNum, outletId, totalAmount) {
    this.postCheckout(orderId).then(async (res) => {
      const paymentStatus = res["body"]["data"]["status"];
      console.log("payment status", paymentStatus);
      if (paymentStatus === "complete") {
        this.loaderService.hide();
        this.clearPollingInterval();
        this.openOrderConfirmationModal(orderId, orderNum);
        this.analyticsService.cleverTapEvent(
          CLEVER_TAP_EVENT.PAYMENT_SUCCESS,
          paymentSuccessFailedCleverTapEvent(orderId, outletId)
        );
        // this.analyticsService.cleverTapEvent(CLEVER_TAP_EVENT.CHANGED, {
        //   "Amount": totalAmount,
        //   "Charged ID": AppData.userId,
        //   "order_id": orderId,
        //   "outletId": outletId,
        // });
        this.changeDetector.detectChanges();
      } else if (paymentStatus === "failed") {
        this.loaderService.hide();
        this.changeDetector.detectChanges();
        this.toast.presentToast(
          ErrorMessage.PAYMENT_IS_FAILED_MSG,
          "",
          "error"
        );
        this.clearPollingInterval();
        this.analyticsService.cleverTapEvent(
          CLEVER_TAP_EVENT.PAYMENT_FAILED,
          paymentSuccessFailedCleverTapEvent(orderId, outletId)
        );
      }
    });
  }

  openOrderConfirmationModal(orderId, orderNum) {
    this.ngZone.run(() => {
      // orderPlaceModalRef.result.then((result) => {
      this.openScratchCardModal(orderId, orderNum);
      setTimeout(() => {
        AppData.yourPlateItemsSub$.next(JSON.parse(JSON.stringify(null)));
        AppData.plateItemCountSub$.next({
          itemCount: 0,
          itemTotal: 0,
          outletName: "",
          outletLogo: "",
          outletId: "",
        });
        AppData.spInstructionsSub$.next("");
      }, 1500);
      // }).catch((result) => {
      //   console.log(result);
      // });
    });
  }
  eventCallingOnOrderStatus(status, orderId) {
    console.log(AppData.yourPlateItems)
    if (AppData.yourPlateItems?.outlets[0]?.outletId) {
      if (status === 'success') {
        this.analyticsService.cleverTapEvent(
          CLEVER_TAP_EVENT.PAYMENT_SUCCESS,
          paymentSuccessObj(orderId, AppData.yourPlateItems['outlets'][0]['outletId'], AppData.yourPlateItems)
        );
      } else {
        this.analyticsService.cleverTapEvent(
          CLEVER_TAP_EVENT.PAYMENT_FAILED,
          paymentFailedObj(orderId, AppData.yourPlateItems['outlets'][0]['outletId'], AppData.yourPlateItems)
        );
      }
    }
  }

  openScratchCardModal(orderId, orderNum) {
    const obj = {
      orderId: orderId,
      orderNum: orderNum,
      navigateToHome: true,
    };
    const navParams = {
      redirectUrl: '/home'
    }
    this.navCtrl.navigateForward(['/order-tracking'], { queryParams: navParams, state: { data: obj } })
  }

  taxAndChargesModal(obj) {
    const modalRef = this.modalService.open(
      TaxAndChargesModalComponent,
      getConfig("TAX_AND_CHARGES_CONFIG")
    );
    modalRef.componentInstance.modalObj = obj;
    console.log(modalRef);
    modalRef.result
      .then(async (res) => {
        console.log(res);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  openCartInvalidModal(errorMsg) {
    const mObj = getMessages("OUTLET_MENU_CLOSE_MSG");
    mObj["msg"] = errorMsg;
    const modalRef = this.modalService.open(
      ConfirmationModalComponent,
      getConfig("CONFIRM_MODAL_CONFIG")
    );
    modalRef.componentInstance.modalObj = mObj;
    modalRef.result
      .then((res) => { })
      .catch((error) => {
        console.log(error);
      });
  }

  // for clear polling interval
  clearPollingInterval() {
    clearInterval(this.interval);
    clearTimeout(this.setTimer);
  }

  openCouponConfirmationModal(discount) {
    const modalRef = this.modalService.open(
      CouponConfirmationModalComponent,
      getConfig("COUPON_CONFIRMATION_CONFIG")
    );
    modalRef.componentInstance.modalObj = discount;
    modalRef.result
      .then((res) => { })
      .catch((error) => {
        console.log(error);
      });
  }

  openPaymentModal(res, type, orderId) {
    const mObj = {
      res: res,
      type: type,
      orderId: orderId
    };
    const modalRef = this.modalService.open(
      PaymentModalComponent,
      getConfig("FROM_RIGHT_MODAL")
    );
    modalRef.componentInstance.modalObj = mObj;
    modalRef.result
      .then(async (res) => {
        this.navCtrl.navigateForward(['/order-confirmation'], { queryParams: { type: 'pending', navigateFrom: '', orderId: res } });
      })
      .catch((error) => {
        console.log(error);
      });
  }
}
